import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Role } from '@/types/models';

interface DeleteRoleDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  role: Role | null;
  onConfirm: () => void;
  userCount: number;
}

export const DeleteRoleDialog: React.FC<DeleteRoleDialogProps> = ({
  isOpen,
  onOpenChange,
  role,
  onConfirm,
  userCount
}) => {
  const isInUse = userCount > 0;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isInUse ? `Cannot Delete "${role?.name}"` : 'Delete Role'}
          </DialogTitle>
          <DialogDescription>
            {isInUse 
              ? `This role cannot be deleted because it is currently assigned to ${userCount} user(s). Please unassign all users from this role first.`
              : `Are you sure you want to delete the role "${role?.name}"? This action cannot be undone.`
            }
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {isInUse ? (
            <Button onClick={() => onOpenChange(false)}>OK</Button>
          ) : (
            <>
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button variant="destructive" onClick={onConfirm}>
                Delete
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 